export const ACCOUNT_COMPLIANCE_EVENT = "lapstr:account-compliance-changed";
const KEY_PREFIX = "lapstr:account-compliance:";

function storageKey(userId) {
  return userId ? `${KEY_PREFIX}${userId}` : null;
}

export function getCachedCompliance(userId) {
  const key = storageKey(userId);
  if (!key || typeof window === "undefined") return null;
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key));
    if (!parsed || parsed.userId !== userId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function cacheCompliance(userId, status) {
  const key = storageKey(userId);
  if (!key || typeof window === "undefined") return;
  const next = {
    userId,
    complete: status?.complete === true,
    isAdult: status?.is_adult === true,
    ageBracket: status?.age_bracket || null,
    updatedAt: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(key, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent(ACCOUNT_COMPLIANCE_EVENT, { detail: next }));
  } catch {
    // Restrictive defaults remain active if local storage is unavailable.
  }
}

export function allowsOptionalTracking(userId) {
  const status = getCachedCompliance(userId);
  return status?.complete === true && status?.isAdult === true;
}
